import { combineReducers } from 'redux';
import options from './options';

const entitiesReducer = combineReducers({
  options,
});

export default entitiesReducer;
